import { PostElementBackground } from "@serializers/article"

import { ContactUsElementRichContent } from "./contact-us-element.styles"

interface ContactUsElementProps {
  background: PostElementBackground
  content: string
}

export function ContactUsElement(props: ContactUsElementProps) {
  const { content, background } = props

  const backgroundBlockColor = (color: string) => {
    switch (color) {
      case "black":
        return "black"
      case "white":
        return "white"
      case "gray":
        return "#F5F3F3"
      default:
        return "black"
    }
  }

  const textBlockColor = (backgroundColor: string) => {
    switch (backgroundColor) {
      case "black":
        return "white"
      default:
        return "black"
    }
  }

  if (background === "white") {
    return (
      <div className="pb-6 pt-4">
        <div className="container">
          <ContactUsElementRichContent src={content} />
        </div>
      </div>
    )
  }

  return (
    <div
      className="pb-6 pt-4"
      style={{ backgroundColor: backgroundBlockColor(background) }}
    >
      <div className="container">
        <ContactUsElementRichContent
          src={content}
          color={textBlockColor(background)}
        />
      </div>
    </div>
  )
}
